import { render, staticRenderFns } from "./approval-period.vue?vue&type=template&id=efdac9fc"
import script from "./approval-period.vue?vue&type=script&lang=js"
export * from "./approval-period.vue?vue&type=script&lang=js"
import style0 from "./approval-period.vue?vue&type=style&index=0&id=efdac9fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports